<ng-container *ngIf="hasMasterDataAccess">
  <div class="d-flex flex-wrap align-items-center justify-content-between">
    <h3>{{ 'generalInformation' | translate }}</h3>
    <base-button
      [size]="buttonSizes.md"
      [color]="isEditMode ? 'primary' : 'secondary'"
      class="mb-2 mb-lg-0"
      [label]="isEditMode ? 'action.save' : 'action.edit'"
      (btnClick)="isEditMode ? saveChanges() : (isEditMode = !isEditMode)"
    ></base-button>
  </div>
  <hr class="mt-1 mb-7" />

  <base-general-info-form
    [form]="mainForm.controls.contact"
    [submitted]="submitted"
    [isEditMode]="isEditMode"
    [hideTitle]="true"
  ></base-general-info-form>
  <base-master-address-form
    class="d-block mb-6"
    [form]="mainForm.controls.businessAddress"
    [submitted]="submitted"
    [isEditMode]="isEditMode"
    headline="businessAddress"
  ></base-master-address-form>
  <base-master-address-form
    class="d-block mb-6"
    [form]="mainForm.controls.billingAddress"
    [submitted]="submitted"
    [isEditMode]="isEditMode"
    [isBillingAddress]="true"
    subTitle="usedInternally"
    (sameAsBusiness)="fillBillingAddress()"
    headline="billingAddress"
  ></base-master-address-form>
  <div
    class="d-flex align-items-center justify-content-end mt-5"
    *ngIf="isEditMode"
  >
    <base-button
      [size]="buttonSizes.md"
      color="primary"
      label="action.save"
      baseScrollToInvalid
      [baseInvalidFormSubmitted]="submitted"
      [baseInvalidForm]="mainForm"
      (btnClick)="saveChanges()"
    ></base-button>
  </div>
  <h3 class="pt-5">{{ 'administration.companySettings.title' | translate }}</h3>
  <hr class="mt-1 mb-5" />
  <base-customer-company-settings-form
    [customer]="customer"
    [form]="companySettingsForm"
    [areEPAndMLPVisible]="!!customer?.equalPayLocationOnly"
    (updateCompanySettings)="updateCompanySettings()"
  ></base-customer-company-settings-form>
</ng-container>
